import { styled } from '@mui/material/styles';
import MUIButtonBase, { ButtonBaseProps as MUIButtonBaseProps } from '@mui/material/ButtonBase';

export type IconButtonProps = {
  children: React.ReactNode;
  onClick?: MUIButtonBaseProps['onClick'];
  disabled?: boolean;
};

const StyledButton = styled(MUIButtonBase)({
  padding: 0,
});

export const IconButton: React.FC<IconButtonProps> = ({ children, ...otherProps }) => {
  return (
    <StyledButton disableTouchRipple disableRipple {...otherProps}>
      {children}
    </StyledButton>
  );
};
